import { useQuery } from "react-query";
import * as annualReportNavBarService from "api/services/annualReportNavBar";

const { getById } = annualReportNavBarService;

// Get the report summary which determines the information and options displayed in the nav bar
export const useAnnualReportNavBar = (municipalityId) =>
  useQuery(["annual", "reports"], () => getById(municipalityId), {
    enabled: municipalityId !== 0,
  });
